// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Ubuntu_c44902', '__Ubuntu_Fallback_c44902'"},"className":"__className_c44902"};